import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Button,
  Stack,
  TextField,
  MenuItem,
  Grid
} from "@mui/material";

import PageHeader from "../../components/common/PageHeader";
import { getVendorBills } from "../../api/accountingApi";

export default function Payables() {

  const [bills, setBills] = useState([]);

  const [filters, setFilters] = useState({
    status: "",
    date_from: "",
    date_to: ""
  });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const res = await getVendorBills(filters);
      setBills(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Payables Error:", err);
    }
  };

  // =========================
  // FILTER CHANGE
  // =========================
  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const applyFilters = () => {
    loadData();
  };

  // =========================
  // STATUS COLOR
  // =========================
  const getStatusColor = (status) => {
    switch (status) {
      case "PAID":
        return "success";
      case "PARTIAL":
        return "warning";
      default:
        return "error";
    }
  };

  // =========================
  // TOTALS
  // =========================
  const totals = bills.reduce(
    (acc, b) => {
      acc.total += b.amount || 0;
      acc.outstanding += b.outstanding_amount || 0;
      return acc;
    },
    { total: 0, outstanding: 0 }
  );

  return (
    <Box className="page">

      {/* HEADER */}
      <PageHeader
        title="Payables"
        subtitle="Manage vendor bills and payments"
      />

      {/* FILTERS */}
      <Paper sx={{ p: 2, mb: 2, borderRadius: 3 }}>
        <Grid container spacing={2}>

          <Grid item xs={3}>
            <TextField
              select
              label="Status"
              name="status"
              fullWidth
              value={filters.status}
              onChange={handleFilterChange}
            >
              <MenuItem value="">All</MenuItem>
              <MenuItem value="PENDING">Pending</MenuItem>
              <MenuItem value="PAID">Paid</MenuItem>
              <MenuItem value="PARTIAL">Partial</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={3}>
            <TextField
              type="date"
              label="From Date"
              name="date_from"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={filters.date_from}
              onChange={handleFilterChange}
            />
          </Grid>

          <Grid item xs={3}>
            <TextField
              type="date"
              label="To Date"
              name="date_to"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={filters.date_to}
              onChange={handleFilterChange}
            />
          </Grid>

          <Grid item xs={3}>
            <Button
              variant="contained"
              fullWidth
              sx={{ height: "100%" }}
              onClick={applyFilters}
            >
              Apply Filters
            </Button>
          </Grid>

        </Grid>
      </Paper>

      {/* TOTALS BAR */}
      <Paper sx={{ p: 2, mb: 2, borderRadius: 3 }}>
        <Stack direction="row" spacing={5}>
          <Typography variant="h6">
            Total Bills: ₹ {totals.total}
          </Typography>

          <Typography variant="h6" color="error">
            Outstanding: ₹ {totals.outstanding}
          </Typography>
        </Stack>
      </Paper>

      {/* ACTION BAR */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h6">Vendor Bills</Typography>

        <Button variant="contained">
          Create Bill
        </Button>
      </Stack>

      {/* TABLE */}
      <Paper sx={{ borderRadius: 3 }}>

        <Table>

          <TableHead>
            <TableRow>
              <TableCell><b>Vendor</b></TableCell>
              <TableCell><b>Bill #</b></TableCell>
              <TableCell><b>Amount</b></TableCell>
              <TableCell><b>Paid</b></TableCell>
              <TableCell><b>Outstanding</b></TableCell>
              <TableCell><b>Status</b></TableCell>
              <TableCell><b>Date</b></TableCell>
              <TableCell><b>Action</b></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>

            {bills.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  No Vendor Bills Found
                </TableCell>
              </TableRow>
            ) : (
              bills.map((b) => (
                <TableRow key={b.id} hover>

                  <TableCell>{b.vendor_name}</TableCell>

                  <TableCell>{b.bill_number}</TableCell>

                  <TableCell>₹ {b.amount}</TableCell>

                  <TableCell>₹ {b.paid_amount || 0}</TableCell>

                  <TableCell>₹ {b.outstanding_amount || 0}</TableCell>

                  <TableCell>
                    <Chip
                      label={b.status}
                      color={getStatusColor(b.status)}
                      size="small"
                    />
                  </TableCell>

                  <TableCell>
                    {b.bill_date || "-"}
                  </TableCell>

                  {/* 🔥 PAY BUTTON */}
                  <TableCell>
                    <Button
                      size="small"
                      variant="outlined"
                      disabled={b.status === "PAID"}
                    >
                      Pay
                    </Button>
                  </TableCell>

                </TableRow>
              ))
            )}

          </TableBody>

        </Table>

      </Paper>
    </Box>
  );
}